module.exports = __webpack_public_path__ + "img/icon-twitter.535eced1.svg";